import axios from "axios";

import { settings } from "@krea/customer-features/settings";
import { CountryCode } from "@krea/shared/types/common";

export interface RegisterPartnerPayload {
  email: string;
  mobile_phone_number: string;
  organisation_name: string;
  organisation_number: string;
  country_code: CountryCode;
}

export const register = async (payload: RegisterPartnerPayload) => {
  return axios.post<null>(
    "/partner/api/v1/partner-organisation/register",
    payload,
  );
};
